import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { TeamworkCollectionLogo } from "@/components/signup/utils";

import { Heading, SubHeading } from "../components";

export const LoggedOutRovo = () => (
    <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
        <Heading>
            <FormattedMessage
                id="signup.teamworkCollection.rovoHeading"
                defaultMessage="Get Teamwork Collection to start using Rovo"
            />
        </Heading>
        <SubHeading>
            <FormattedMessage
                id="signup.teamworkCollection.rovoSubHeading"
                defaultMessage="Free for up to ten users. Start using Rovo in 20 minutes or less after sign-up."
            />
        </SubHeading>
        <AccountCreation />
    </SignupBackgroundLayout>
);
